import {StoreObj} from './store-obj';

export class RefreshStoreRequest {
  store: StoreObj;

  constructor(store: StoreObj) {
    this.store = store;
  }
}
